export default __webpack_public_path__ + "static/toolsDevMobile-2fb3054ed2be9a7325c875bb6f77fd6e.png";